import { css as o } from "@emotion/react";
function l(e, i) {
  return /* @__PURE__ */ o("position:relative;display:-webkit-box;max-block-size:calc(", e, " * ", i, ");line-height:", i, ";text-overflow:ellipsis;overflow:hidden;-webkit-box-orient:vertical;-webkit-line-clamp:", e, ";", "");
}
export {
  l as s
};
//# sourceMappingURL=fonts-BK4LfyMn.mjs.map
